import { Store } from '@nextforce/api'
import { Icon, makeStyles, Text } from '@rneui/themed'
import { t } from 'app/i18l'
import { NonAvailabilityGrid } from 'non_availability/non_availability_grid'
import {
  StoreUserNonAvailability,
  UpdateNonAvailabilityParams,
} from 'non_availability/queries/types'
import { Cell } from 'non_availability/types'
import { useEffect, useState } from 'react'
import { View  } from 'react-native'
import { SafeAreaView } from 'react-native-safe-area-context'
import { ScrollView } from 'react-native-gesture-handler'
import { RoundedButton } from 'shared/components/rounded-button'

interface Props {
  nonAvailability?: StoreUserNonAvailability
  store?: Store
  cells?: Cell[]
  onNonAvailabilityParamsChanged(
    nonAvailabilityData: UpdateNonAvailabilityParams
  ): void
  onAddNonAvailability(): void
  loading: boolean
}

export function AddNonAvailabilityView({
  nonAvailability,
  store,
  cells,
  onNonAvailabilityParamsChanged,
  onAddNonAvailability,
  loading,
}: Props) {
  const styles = useStyles()

  const [selectedCells, setSelectedCells] = useState<Cell[]>(cells ?? [])

  useEffect(() => {
    onNonAvailabilityParamsChanged({
      nonAvailabilities: selectedCells,
    })
  }, [onNonAvailabilityParamsChanged, selectedCells])

  return (
    <View style={{ flex: 1 }}>
      <ScrollView
        contentContainerStyle={styles.container}
        bounces={true}
        scrollEnabled={true}
      >
        <View style={styles.explanationContainer}>
          <Icon
            name="information-circle-outline"
            type="ionicon"
            size={20}
            iconStyle={{ marginRight: 10 }}
          />
          <Text style={styles.explanation}>
            {nonAvailability
              ? getMessage(nonAvailability.status)
              : t('requestNonAvailabilityExplanationMessage')}
          </Text>
        </View>
        <NonAvailabilityGrid
          store={store}
          cells={cells}
          onCellPress={setSelectedCells}
          disableSelection={
            nonAvailability?.status === 'PENDING' ? true : false
          }
        />
      </ScrollView>
      <SafeAreaView edges={['left', 'right', 'bottom']}>
        <RoundedButton
          danger
          onPress={onAddNonAvailability}
          title={t('submitRequest')}
          buttonStyle={styles.buttonStyle}
          loading={loading}
          disabled={nonAvailability?.status === 'PENDING' ? true : false}
        />
      </SafeAreaView>
    </View>
  )
}

function getMessage(status?: string) {
  if (!status) {
    return ''
  }
  switch (status) {
    case 'PENDING':
      return t('requestNonAvailabilityPendingMessage')
    case 'APPROVED':
      return t('requestNonAvailabilityApprovedMessage')
    default:
      return ''
  }
}

const useStyles = makeStyles(theme => ({
  container: {
    flexGrow: 1,
    padding: 16,
    paddingTop: 10,
    backgroundColor: theme.colors?.white,
  },
  head: {
    height: 70,
    backgroundColor: '#f1f8ff',
  },
  wrapper: {
    flexDirection: 'row',
  },
  title: {
    flex: 1,
    backgroundColor: '#f1f8ff',
  },
  row: {
    height: 58,
    borderWidth: 0,
  },
  text: {
    textAlign: 'center',
    flexWrap: 'wrap',
    fontSize: 12,
    margin: 2,
  },
  time: {
    textAlign: 'center',
    flexWrap: 'wrap',
    margin: 2,
    fontSize: 9,
  },
  explanationContainer: {
    marginHorizontal: 10,
    marginVertical: 20,
    paddingHorizontal: 5,
    flexDirection: 'row',
    alignItems: 'center',
  },
  explanation: {
    color: theme.colors.grey2,
    textAlign: 'justify',
    flexShrink: 1,
    flexWrap: 'wrap',
  },
  buttonStyle: {
    margin: 5,
  },
}))
